// extracted by mini-css-extract-plugin
export default {"heading":"CreditDetailsHeader_heading__3RXE+","grid":"CreditDetailsHeader_grid__pBuj-"};